module.exports = __webpack_public_path__ + "static/023_001-0e6dd4fd026f87b9f7d6366e7c188fb1.jpg";